module.exports = __webpack_public_path__ + "assets/img/baianji.032ab5c2.svg";